export default __webpack_public_path__ + "static/media/Entourage_L3.bab5964f.png";